/* eslint-disable import/prefer-default-export */
export const modifiedPlusImageLink =
  "//cdnimg.webstaurantstore.com/uploads/design/2024/12/plus_badge_variations.svg";
